import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M2.0007 6.9098C2.0312 4.9494 3.1017 2.6755 11.66 3.03c-.16.36-1.14 2.37-.37 4.97H4v3h9.11c1.26 1.24 2.98 2 4.89 2v3.5c0 .95-.38 1.81-1 2.44v1.56c0 .83-.68 1.5-1.5 1.5l-.1447-.007C14.5935 21.9196 14 21.2719 14 20.5V20H6v.5c0 .83-.67 1.5-1.5 1.5l-.1447-.0069A1.4979 1.4979 0 013 20.5v-1.56c-.62-.63-1-1.49-1-2.44zM6.5 14c-.83 0-1.5.67-1.5 1.5S5.67 17 6.5 17 8 16.33 8 15.5 7.33 14 6.5 14zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zM18 1c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm0 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.28-.22-.5-.5-.5z"
  }],
  circles: []
};
var BusAlertIcon = function BusAlertIcon(props) {
  return renderIcon(props, iconType);
};
export { BusAlertIcon };